import { Injectable } from '@angular/core';
import { RepositoryService } from '../baseServices/repository.service';
import { StoreName } from '../entities/StoreName';
import { EqualFilter } from '../baseServices/filter.interface';
import { DbTransaction } from '../models/db/db-transaction';
import { FIPSState } from '../entities/FIPSState';
@Injectable({
  providedIn: 'root',
})
export class LookupService {
  constructor(private repository: RepositoryService) {}

  async getEntityId(entity: string, existingTransaction?: DbTransaction): Promise<number> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    let entityId: number;
    type Filter = EqualFilter;
    const filterData: Filter = {
      equals: {
        field: 'Number',
        searchString: entity,
        caseInsensitive: true,
      },
    };

    const storeData = await this.repository.getAll(StoreName.EntityType, filterData, undefined, transaction);
    if (storeData && storeData.length > 0) {
      entityId = storeData[0].Id;
    }

    if (!existingTransaction) {
      await this.repository.commitTransaction(transaction);
    }

    return entityId;
  }

  async getAllFipsStates(filter: any = undefined): Promise<FIPSState[]> {
    return await this.repository.getAll(StoreName.FIPSState, filter);
  }

  async getFipsStateById(id: number): Promise<FIPSState | undefined> {
    return await this.repository.getByOnlineId(StoreName.FIPSState, id);
  }

  async getFipsStateNumberById(id: number) {
    const fipsState = await this.getFipsStateById(id);
    if (fipsState) {
      return fipsState.Number;
    } else {
      return null;
    }
  }

  async getFipsStateNumberByName(name: string) {
    const filterData: EqualFilter = {
      equals: {
        field: 'Name',
        searchString: name,
      },
    };
    const fipsStates = await this.getAllFipsStates(filterData);
    if (fipsStates && fipsStates.length > 0) {
      return fipsStates[0].Number;
    } else {
      return null;
    }
  }

  private async startTransactionIfNeeded(existingTransaction?: DbTransaction): Promise<DbTransaction> {
    return existingTransaction || (await this.repository.startTransaction([StoreName.EntityType], 'readwrite'));
  }
}
